import { render, staticRenderFns } from "./FoodMenuDataTable.vue?vue&type=template&id=ffe27ae4&scoped=true&"
import script from "./FoodMenuDataTable.vue?vue&type=script&lang=js&"
export * from "./FoodMenuDataTable.vue?vue&type=script&lang=js&"
import style0 from "./FoodMenuDataTable.vue?vue&type=style&index=0&id=ffe27ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe27ae4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VDataTable,VIcon,VImg})
